import { render } from "./info.vue?vue&type=template&id=2aa8e142&scoped=true"
import script from "./info.vue?vue&type=script&lang=js"
export * from "./info.vue?vue&type=script&lang=js"

import "./info.vue?vue&type=style&index=0&id=2aa8e142&lang=scss&scoped=true"

import exportComponent from "D:\\GitLocal\\mvs-sys\\mvsui-user\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aa8e142"]])

export default __exports__